import React from 'react';
import { Check, ShieldCheck, Lock, Zap, CreditCard } from 'lucide-react';
const CHECKOUT_URL = 'https://rugby360.impultienda.ar/checkout';
const included = ['Complete Box Set (14 volumes)', '6 Strategic Bonuses', '365-Day Coaching Curriculum', 'Lifetime access', 'Instant digital access'];
export function Pricing() {
  const goToCheckout = () => {
    // Track InitiateCheckout if the Meta Pixel is available, then redirect
    try {
      ;
      (window as any).fbq?.('track', 'InitiateCheckout');
    } catch {
      /* ignore */
    }
    window.location.href = CHECKOUT_URL;
  };
  return <section id="offer-details" className="bg-[#F4F6F2] px-4 py-14 md:py-24" data-id="element-155" data-mp="25sr41y2g882a">
      <div className="max-w-3xl mx-auto" data-id="element-156" data-mp="20t4q1mesqnsf">
        <div className="text-center mb-9 md:mb-12" data-id="element-157" data-mp="20sd473b044fc">
          <span className="inline-block bg-ink text-acid text-[0.65rem] md:text-[11px] font-bold uppercase tracking-[0.16em] px-4 py-2 md:px-5 md:py-2.5 mb-5 md:mb-7" data-id="element-158" data-mp="3h7ebo8rnlyfk">
            Limited-time offer
          </span>
          <h2 className="font-display uppercase text-gray-900 text-[7.4vw] min-[430px]:text-3xl md:text-5xl leading-[1.05] mb-3" data-id="element-159" data-mp="3vzyl0bozqz0g">
            Everything included,{' '}
            <span className="text-neon-deep" data-id="element-160" data-mp="4uytyx40s28o">one single price.</span>
          </h2>
          <p className="text-gray-500 text-sm md:text-lg" data-id="element-161" data-mp="9t0apbdz3pgz">
            No upsells. No surprises.
          </p>
        </div>

        <div className="bg-white shadow-xl border-t-4 border-neon" data-id="element-162" data-mp="3d8z3twnqmthq">
          <header className="bg-ink text-center px-5 py-7 md:px-6 md:py-9" data-id="element-163" data-mp="3dascfhhwvnsd">
            <h3 className="font-display uppercase text-white text-xl md:text-3xl leading-tight mb-2" data-id="element-164" data-mp="3i8ttxxzovf1q">
              Rugby 360 — Complete Box Set
            </h3>
            <p className="text-acid text-xs md:text-base font-medium" data-id="element-165" data-mp="3rxlhzv1mpf7d">
              1 Main Box Set (14 volumes) + 6 Strategic Bonuses
            </p>
          </header>

          <div className="p-5 md:p-10" data-id="element-166" data-mp="2ugd9xhwe5czs">
            <p className="text-center text-[0.7rem] md:text-xs font-bold uppercase tracking-[0.16em] text-gray-500 mb-5 md:mb-7" data-id="element-167" data-mp="2zh0y7vt8jfqb">
              What's included
            </p>

            <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-3 md:gap-y-4 mb-8 md:mb-10" data-id="element-168" data-mp="2mhrsvo25dg34">
              {included.map(item => <li key={item} className="flex items-center gap-2.5 md:gap-3" data-id="element-169" data-mp="316xufiogjie6">
                  <span className="w-5 h-5 md:w-6 md:h-6 rounded-full bg-neon/20 text-neon-deep flex items-center justify-center flex-shrink-0" data-id="element-170" data-mp="2w7utoafifyc0">
                    <Check size={13} strokeWidth={3} aria-hidden="true" data-id="element-171" data-mp="28iiodlnb0aez" />
                  </span>
                  <span className="font-bold text-gray-900 text-[0.85rem] md:text-[0.95rem]" data-id="element-172" data-mp="23kgxwfnjt8th">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="border-t border-gray-200 pt-7 md:pt-9 text-center" data-id="element-173" data-mp="2dfimnadww8vj">
              <p className="text-gray-500 text-sm md:text-base mb-2" data-id="element-174" data-mp="3tuaglrqpho6y">
                Regular price: <span className="line-through" data-id="element-175" data-mp="3ox1szbmsgryb">$97 USD</span>
              </p>

              <div className="flex items-start justify-center gap-1 mb-5" data-id="element-176" data-mp="ana6bsdrwnn">
                <span className="font-display text-gray-900 text-3xl md:text-5xl mt-2 md:mt-3" data-id="element-177" data-mp="cqbhryzhc7o">
                  $
                </span>
                <span className="font-display text-gray-900 text-[4.5rem] md:text-[7rem] leading-[0.85]" data-id="element-178" data-mp="3nfv2s6hoa3ns">
                  27
                </span>
                <span className="text-gray-500 text-base md:text-xl font-medium self-end mb-2 md:mb-3 ml-1" data-id="element-179" data-mp="3rirfjgkj75jt">
                  USD
                </span>
              </div>

              <div className="flex flex-wrap items-center justify-center gap-2.5 md:gap-4 mb-7 md:mb-9" data-id="element-180" data-mp="nyn3njh2u15x">
                <span className="bg-neon text-ink text-[0.65rem] md:text-xs font-bold uppercase tracking-[0.1em] px-3 py-1.5 md:px-4 md:py-2" data-id="element-181" data-mp="a81qmbeb0lfy">
                  Save $70
                </span>
                <span className="text-gray-600 text-[0.65rem] md:text-xs font-bold uppercase tracking-[0.1em]" data-id="element-182" data-mp="11yxw2qy1bnt7">
                  One-time payment
                </span>
                <span className="text-gray-600 text-[0.65rem] md:text-xs font-bold uppercase tracking-[0.1em]" data-id="element-183" data-mp="3f81tx0503cqg">
                  Lifetime access
                </span>
              </div>

              <button onClick={goToCheckout} className="w-full bg-neon hover:bg-neon-light text-ink font-display uppercase text-lg md:text-2xl tracking-wide py-5 md:py-6 rounded-xl shadow-[0_5px_0_0_var(--neon-deep)] active:translate-y-[3px] active:shadow-[0_2px_0_0_var(--neon-deep)] transition-all" data-id="element-184" data-mp="3592vsbhv2zhp">
                Get Rugby 360 Now
              </button>

              <p className="flex items-center justify-center gap-2 text-gray-500 text-xs md:text-sm mt-4 md:mt-5" data-id="element-185" data-mp="3o7orfaulzye8">
                <ShieldCheck className="text-neon-deep" size={15} data-id="element-186" data-mp="3k5k4euyo200k" />
                Backed by our 7-day money-back guarantee
              </p>
            </div>

            <div className="border-t border-gray-200 mt-7 md:mt-9 pt-5 md:pt-7 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs md:text-sm text-gray-600" data-id="element-187" data-mp="fseyas8p63il">
              <span className="flex items-center gap-1.5" data-id="element-188" data-mp="1ygpv211ww0wv">
                <Lock size={14} data-id="element-189" data-mp="23dq3gim8hfr5" /> Secure payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-190" data-mp="23g2ox5r7a88y">
                <Zap size={14} data-id="element-191" data-mp="27f1pyf9t9kv4" /> Instant access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-192" data-mp="2cffu3m8akanv">
                <CreditCard size={14} data-id="element-193" data-mp="2cctmxnpbbx66" /> Card · GooglePay · ApplePay
              </span>
            </div>
          </div>
        </div>

        <p className="text-center text-gray-500 text-xs md:text-sm mt-5 md:mt-7" data-id="element-194" data-mp="2mckebgiktw21">
          You'll be charged in your local currency.
        </p>
      </div>
    </section>;
}